<template>
  <div  :class="isEyeshield ? 'dashboardIndex_eyeshield' : 'dashboardIndex'">
    <div class="mapWrap" >
      <ThreedDashboard :isEyeshield="isEyeshield" width="100%" height="100%;"></ThreedDashboard>
      <!--      <map2d actionScope="index"></map2d>-->
    </div>
    <div class="contentWrap">
      <div class="leftContent">
        <div class="contentItem" style="height: 65%;">
          <div class="itemTitle">
            <div class="itemTitleText">飞行活动</div>
          </div>
          <div class="taskcontent_2d" >
            <div class="taskSearchBox" >
              <el-input
                placeholder="飞机型号,驾驶员,执照号,运营人,备注"
                v-model="searchTaskKeyWord "
                @keyup.enter.native="searchClick"
              >
                <i slot="suffix" class="el-input__icon el-icon-search" @click="searchClick"></i>
              </el-input>
            </div>

            <div class="listAll_2d" v-if="taskList.length !== 0">
              <div
                class="task-item_2d"
                v-for="item in taskList"
                :key="item.id"
                :title="'飞机号:'+item.uavSerial"
                @click="showPlanDetail(item)"
              >
                <div class="donePlan common" v-if="item.status==13||item.status==14">
                  <div  class="firstSpan" >{{ item.operatorSimpleName }}</div>
                  <div class="secondSpan" >{{ item.pilot }}</div>
                  <div class="thirdSpan" >
                    {{ item.type == 0 ? '观光' : item.type == 1 ? '巡检' : item.type == 2 ?'物流' :  item.type == 3 ?'应急':'物流' }}
                  </div>
                  <div style="color: #ee3f3f">已执行</div>
                  <div class="itemDetail"></div>
                </div>
                <div class="executePlan common" v-if="item.status==10||item.status==11||item.status==12">
                  <div  class="firstSpan" >{{ item.operatorSimpleName }}</div>
                  <div class="secondSpan" >{{ item.pilot }}</div>
                  <div class="thirdSpan" >
                    {{ item.type == 0 ? '观光' : item.type == 1 ? '巡检' : item.type == 2 ?'物流' :  item.type == 3 ?'应急':'物流' }}
                  </div>
                  <div style="color: #00ffff">执行中</div>
                  <div class="itemDetail"></div>
                </div>
                <div class="prePlan common" v-if="item.status==0||item.status==1||item.status==2||item.status==3||item.status==4||item.status==5||item.status==6||item.status==7||item.status==8||item.status==9">
                  <div  class="firstSpan" >{{ item.operatorSimpleName }}</div>
                  <div class="secondSpan" >{{ item.pilot }}</div>
                  <div class="thirdSpan" >
                    {{ item.type == 0 ? '观光' : item.type == 1 ? '巡检' : item.type == 2 ?'物流' :  item.type == 3 ?'应急':'物流' }}
                  </div>
                  <div style="color: #00aeff">待执行</div>
                  <div class="itemDetail"></div>
                </div>

              </div>
            </div>
            <div class="emptyWrap" v-if="taskList.length == 0">
              <Empty/>
            </div>
          </div>
        </div>
        <div class="contentItem10">
          <div class="itemTitle">
            <div class="itemTitleText">地面基础设施统计</div>
          </div>
          <div class="screenItemContent topBox">
            <div style="display: flex;justify-content: space-between;width: 100%;">
              <div class="rightTopTop">
                <div class="rightTopTopContent">

                  <div class="contentText">起降场数量</div>
                  <div class="redLine"></div>
                  <div class="contentFigure">
                    {{
                      this.facilitiesData.takeOffTotalNum != undefined
                        ? this.facilitiesData.takeOffTotalNum
                        : NaN
                    }}
                  </div>
                </div>
              </div>
              <div class="rightTopTop">
                <div class="rightTopTopContent">

                  <div class="contentText" style="text-align: right;">通导监测反制设备</div>

                  <div class="redLine" style="float: right"></div>
                  <div class="contentFigure" style="text-align: right;margin-top: 23px">
                    {{
                      this.facilitiesData.equipmentTotalNum != undefined
                        ? this.facilitiesData.equipmentTotalNum
                        : NaN
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div style="display: flex">
              <div class="rightTopBottom" style="margin-right: 8px">
                <div class="rightTopTopTitle" style="margin-left: 0;">起降场站</div>
                <div class="redLine" style="float: left;margin-top: -6px;"></div>
                <div style="width: 100%;height: 60px;display: flex;">
                  <div class="occupy flex-space"
                       style="width: 40%;height: 100%;display: flex;flex-direction: column;margin-top: 8px;">
                    <div class="name" style="margin-left:0;width: 100%;text-align: left;">空闲</div>
                    <div class="num" style="text-align: left;margin-left: 5px;">
                      {{
                        this.facilitiesData.takeOffIdleNum != undefined
                          ? this.facilitiesData.takeOffIdleNum
                          : NaN
                      }}
                    </div>
                  </div>
                  <div class="emptyItem flex-space"
                       style="width: 60%;height: 100%;display: flex;flex-direction: column;margin-top: 8px;">
                    <div class="name" style="margin-left:0;width: 100%;text-align: left;">占用</div>
                    <div class="num" style="text-align: left;width: 100%;">
                      {{
                        this.facilitiesData.takeOffUseNum != undefined
                          ? this.facilitiesData.takeOffUseNum
                          : NaN
                      }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="rightTopBottom">
                <div class="rightTopTopTitle" style="text-align: right;">设备状态</div>
                <div class="redLine" style="float: right;margin-top: -6px;"></div>
                <div style="width: 100%;height:60px;display: flex;">
                  <div class="occupy flex-space"
                       style="width: 60%;height: 100%;display: flex;flex-direction: column;margin-top: 8px;">
                    <div class="name" style="margin-left: 53px;">在线</div>
                    <div class="num">
                      {{
                        this.facilitiesData.equipmentOnlineNum != undefined
                          ? this.facilitiesData.equipmentOnlineNum
                          : NaN
                      }}
                    </div>
                  </div>
                  <div class="emptyItem flex-space"
                       style="width: 40%;height: 100%;display: flex;flex-direction: column;margin-top: 8px;">
                    <div class="name">离线</div>
                    <div class="num">
                      {{
                        this.facilitiesData.equipmentOfflineNum != undefined
                          ? this.facilitiesData.equipmentOfflineNum
                          : NaN
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rightContent">
        <div class="contentItem">
          <div class="itemTitle">
            <div class="itemTitleText">飞行概览</div>
          </div>
          <div class="inspectionContentWrap">
            <div class="flyTop flyTop1">
              <div
                @click="
                chartType = 1;
                initChangeChart();
              "
                :class="chartType === 1 ? 'flyTopTop' : ''"
                class="fa-mouse-pointer"
              >

                <div class="flyText">

                  运行小时数
                </div>
                <div class="canChangeFigure">
                  {{
                    this.planViewData.safeHours != undefined
                      ? this.planViewData.safeHours
                      : NaN
                  }}

                </div>
              </div>
              <div
                @click="
                chartType = 2;
                initChangeChart();
              "
                :class="chartType === 2 ? 'flyTopTop' : ''"
                class="fa-mouse-pointer"
              >
                <div class="flyText">运行架次</div>
                <div class="canChangeFigure">
                  {{
                    this.planViewData.flySorties != undefined
                      ? this.planViewData.flySorties
                      : NaN
                  }}
                </div>
              </div>
              <div
                @click="
                chartType = 3;
                initChangeChart();
              "
                :class="chartType === 3 ? 'flyTopTop' : ''"
                class="fa-mouse-pointer"
              >
                <div class="flyText">运行里程</div>
                <div class="canChangeFigure">
                  {{
                    this.planViewData.miles != undefined
                      ? this.planViewData.miles
                      : NaN
                  }}
                </div>
              </div>
            </div>
            <div
              style="
              width: 100%;
              height: calc(100% - 50px);
              min-height: 170px;
              overflow: hidden;
            "
              id="flyDataCharts"
            ></div>
          </div>
        </div>
        <div class="contentItem">
          <div class="itemTitle">
            <div class="itemTitleText">飞行活动</div>
          </div>
          <div class="inspectionContentWrap">
            <div class="flyTop flyTop2">
              <div>

                <div class="flyText">历史飞行</div>
                <div class="unActiveFigure">
                  {{
                    this.planActivity.historyTimes != undefined
                      ? this.planActivity.historyTimes
                      : NaN
                  }}
                </div>

              </div>
              <div style="padding-left: 15px;">

                <div class="flyText">当日飞行</div>
                <div class="unActiveFigure">
                  {{
                    this.planActivity.todayTimes != undefined
                      ? this.planActivity.todayTimes
                      : NaN
                  }}
                </div>

              </div>
              <div>
                <div class="flyText">当日待飞行</div>
                <div class="unActiveFigure" style="padding-left: 24px;">
                  {{
                    this.planActivity.todayUnTimes != undefined
                      ? this.planActivity.todayUnTimes
                      : NaN
                  }}
                </div>

              </div>
            </div>
            <div
              style="
              width: 100%;
              height: calc(100% - 50px);
              min-height: 170px;
              overflow: hidden;
            "
              id="flyActiveCharts"
            ></div>
          </div>
        </div>
        <div class="contentItem">
          <div class="itemTitle">
            <div class="itemTitleText">飞行器</div>
          </div>
          <div class="inspectionContentWrap">
            <div style="display: flex; box-sizing: border-box;">
              <div class="rightBottomTop flexCenter" style="margin-right: 9px">
                <div class="rightBottomTopContent" style="display: flex;width: 100%;">
                  <!-- <div class="titleShuFenge" style="background: #ff8c4d"></div> -->
                  <img :src="require(`../../../assets/img/${isEyeshield?'2dmap_eyes':'2dmap'}/fei_xing_qi_zong_sshu.png`)" alt="">
                  <div class="titleBgL">

                    <div class="contentFigure ordinaryFigure">
                      {{ this.aircraftData.totalNum }}
                    </div>
                    <div class="contentText ordinaryText">飞行器总数</div>
                  </div>
                </div>
              </div>
              <div class="rightBottomTop flexCenter">
                <div class="rightBottomTopContent" style="display: flex;width: 100%;margin-left: 15px;">
                  <!-- <div class="titleShuFenge" style="background: #ff5555"></div> -->
                  <img :src="require(`../../../assets/img/${isEyeshield?'2dmap_eyes':'2dmap'}/fei_xing_qi_zong_sshu.png`)" alt="">
                  <div class="titleBgR">

                    <div class="contentFigure ordinaryFigure">
                      {{ this.aircraftData.flyingNum }}
                    </div>
                    <div class="contentText ordinaryText">飞行中</div>
                  </div>
                </div>
              </div>
            </div>
            <div style="height: calc(100% - 108px)">
              <div class="levelWrap">
                <div
                  class="RightBottomBottom"
                  v-if="
                  this.aircraftData.detail.length > 1 ||
                  this.aircraftData.detail.length == 1
                "
                >
                  <div class="shortShuFenge">1</div>
                  <div class="rightBottomBottomText" style="border-bottom: 2px solid #00AEFF;">
                    {{
                      this.aircraftData.detail[0] &&
                      this.aircraftData.detail[0].owner
                    }}
                  </div>
                  <div class="processStyle">
                    <el-progress
                      :text-inside="true"
                      color="#00FFFF"
                      :show-text="false"
                      :percentage="
                      this.aircraftData.detail[0] &&
                      this.aircraftData.detail[0].rate
                    "
                    ></el-progress>
                  </div>
                  <div class="RightBottomBottomFigure">
                    {{
                      this.aircraftData.detail[0] &&
                      this.aircraftData.detail[0].num
                    }}
                  </div>
                </div>
                <div
                  class="RightBottomBottom"
                  v-if="
                  this.aircraftData.detail.length > 2 ||
                  this.aircraftData.detail.length == 2
                "
                >
                  <div class="shortShuFenge">2</div>
                  <div class="rightBottomBottomText" style="border-bottom: 2px solid #00FFFF;">
                    {{
                      this.aircraftData.detail[0] &&
                      this.aircraftData.detail[1].owner
                    }}
                  </div>
                  <div class="processStyle">
                    <el-progress
                      :text-inside="true"
                      color="#00FFFF"
                      :show-text="false"
                      :percentage="
                      this.aircraftData.detail[0] &&
                      this.aircraftData.detail[1].rate
                    "
                    ></el-progress>
                  </div>
                  <div class="RightBottomBottomFigure">
                    {{
                      this.aircraftData.detail[0] &&
                      this.aircraftData.detail[1].num
                    }}
                  </div>
                </div>
                <div
                  class="RightBottomBottom"
                  v-if="
                  this.aircraftData.detail.length > 3 ||
                  this.aircraftData.detail.length == 3
                "
                >
                  <div class="shortShuFenge">3</div>
                  <div class="rightBottomBottomText" style="border-bottom: 2px solid #00AEFF;">
                    {{
                      this.aircraftData.detail[0] &&
                      this.aircraftData.detail[2].owner
                    }}
                  </div>
                  <div class="processStyle">
                    <el-progress
                      color="#00FFFF"
                      :show-text="false"
                      :text-inside="true"
                      :percentage="
                      this.aircraftData.detail[0] &&
                      this.aircraftData.detail[2].rate
                    "
                      status="exception"
                    ></el-progress>
                  </div>
                  <el-progress
                    :text-inside="true"
                    :percentage="50"
                    status="exception"
                  ></el-progress>
                  <div class="RightBottomBottomFigure">
                    {{
                      this.aircraftData.detail[0] &&
                      this.aircraftData.detail[2].num
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PlanDetail :taskForm="taskForm" :clickButton="clickButton"   @update:dialogVisible="updateDialogVisible" @closeForm="closeForm"
    ></PlanDetail>
  </div>
</template>

<script>
import echarts from "echarts";
// import map2d from './map2d.vue'
import PlanDetail from "../../../common/PlanDetail.vue";
import ThreedDashboard from "../../../components/home/ThreedDashboard"
import Empty from "../../../common/Empty.vue"
export default {
  props: {
    //大屏是否显示护眼模式
    isEyeshield: {
      type: Boolean,
      default: true
    },
     //大屏ws
    wsBigScreen: {
      type: WebSocket,
      default: null
    }
  },
  components: {
    // map2d,
    PlanDetail,
    ThreedDashboard,
    Empty
  },
  name: "index",
  data() {
    return {
      planViewData:{},//飞行概览数据
      planActivity:{},//飞行活动数据
      aircraftData:{detail:[]},//飞行器数据
      taskForm:{},
      clickButton:false,
      searchTaskKeyWord:'',
      taskList:[],
      timeInfo: {
        currentTime: "10:04:06",
        date: "2020-10-20",
        weekday: "星期一"
      },
      chartType: 1,//右侧折线图切换1.运行小时数2.运行架次3.运行里程
      leftTop:null,
      rightCenter:null,
      rightBottom:null,
      rightTop:null,
      rightTopData:[],
      leftTopData:[],
      rightCenterData:[],
      rightBottomData:[],
      bottomClick:'2',
      runTask: [], //执行中计划
      preTask: [], //待执行计划
      doneTask: [], //已执行计划
      changeRunTask: [], //处理后的计划
      searchDoneTask:'',
      searchRealTask:'',
      searchPreTask:'',
      // 存储被点击的id
      startIds:[],
      changeIds:[],
      downIds:[],
      facilitiesData:{},//地面基础设施数据
      loginUrl:!location.hostname.toString().includes('192.168.205')?'http://220.248.31.148:9601':"http://192.168.205.105:9601",//本地地址
      inspectionHistory:{arr:[]},//巡检历史统计数据
      inspectionWeek:{},//巡检当周统计数据
      inspectionDefect:[],//巡检缺陷史统计数据
      inspectionKey:'e3dea0f5-37f2-4d79-ae58-490af3228069',//巡检key
    };
  },
  watch:{
    runTask(){
      this.changeRunTask = this.runTask.map(v=>({...v,startChecked:false,changeChecked:false,downChecked:false}))
    },
    isEyeshield: {
      handler(newVal, oldVal) {
        this.rightCenter.setOption({
           tooltip: {
          trigger: 'axis', // 鼠标悬停时触发
          formatter: function (params) {
            let result = `<strong>${params[0].name}</strong><br/>`; // 显示时间
            params.forEach(item => {
              result += `飞行次数: ${item.value[1]}次<br/>`; // 显示数据
            });
            return result;
          },
          backgroundColor: '#fff',
          borderColor: '#ccc',
          borderWidth: 1,
          padding: 10,
          textStyle: {
            color: '#333',
            fontSize: 14
          }
        },
        grid: {
          top: 33,
          left: 50,
          right: 30,
          bottom: 20,
          width: 'auto',
          height: 'auto',
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)', // 坐标轴颜色
            }
          },
          axisLabel: {
            color: '#fff', // 坐标字体颜色
          },
          axisTick: {
            show: false, // 去掉轴刻度线
          },
        },
        yAxis: {
          name: '(次)',
          type: 'value',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)', // 坐标轴颜色
            }
          },
          axisLabel: {
            color: '#fff', // 坐标字体颜色
          },
          axisTick: {
            show: false, // 去掉轴刻度线
          },
          nameTextStyle: {
            color: '#fff',
          },
          splitLine: {
            //网格线
            lineStyle: {
              type: "solid",
              color: "rgba(255, 255, 255, 0.3)"
            },
            show: true,
          },
        },
        series: [
          {
            type: 'line',
            showSymbol: false, // 隐藏所有数据点
            // smooth: 1,
            lineStyle: {
              color: this.isEyeshield?'#fff':'#00ffff',
              width: 3
            },
            areaStyle: {
              normal: {
                color: {
                  type: 'linear', // 线性渐变
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    { offset: 0,color: this.isEyeshield?'rgba(255,255,255,0.80)':'#00FFFF' }, // 0% 处的颜色
                    { offset: 1, color: this.isEyeshield?'rgba(255,255,255,0.00)':'rgba(0, 255, 255, 0)' }  // 100% 处的颜色
                  ],
                  global: false // 使用区域渐变
                }
              }
            },
            data: this.planActivity.TimesArr,
            itemStyle: {
              // 设置数据点的大小和样式
              color: '#00FFFF', // 数据点颜色
              borderColor: '#00FFFF',
              borderWidth: 1, // 边框宽度
            },
          }

        ]
        })
      }}
  },
  mounted() {
    this.setTime();
    this.getPageData()
    window.addEventListener('resize', this.handleResize, {passive: true});
    window.timer = setInterval(this.setTime, 1000)
    this.queryPlan()
    window.queryTaskTimer = setInterval(()=>{
      this.queryPlan();
      this.getFacilitiesData()
    }, 20000);
    // window.addEventListener("message", function(event) {
    //   // 这里可以添加安全性验证，例如检查来源
    //   if (event.origin === window.location.origin) {
    //     // 更新父组件的属性
    //     console.log(event.data.newValue,444)
    //   }
    // });
  },
  beforeDestroy(){
    clearInterval(window.timer)
    clearInterval(window.queryTaskTimer)
  },
  methods: {
    //获取地面基础设施
    getFacilitiesData(){
      return  this.getRequest(
        '/uav-task-server/planstatistic/getInfrastructure?regionCode=310106'
      ).then(
        res => {
          let oData = res.data;
          if (oData.code == 0) {
            let records = oData.data;
            this.facilitiesData = records
          }
        })
    },
    //获取飞行活动数据
    getPlanActivity(){
      return  this.getRequest(
        '/uav-task-server/planstatistic/getPlanActivity'
      ).then(
        res => {
          let oData = res.data;
          if (oData.code == 0) {
            let records = oData.data;
            this.planActivity = {
              historyTimes:records.historyTimes,
              todayTimes:records.todayTimes   ,
              todayUnTimes:records.todayUnTimes,
              TimesArr:records.monthTimes.map(v=>{
                return [v.month,v.nums]
              }),
            }
          }
        })
    },
    //获取飞行概览数据
    getPlanView(){
      return  this.getRequest(
        '/uav-task-server/planstatistic/getPlanView'
      ).then(
        res => {
          let oData = res.data;
          if (oData.code == 0) {
            let records = oData.data;
            this.planViewData = {
              flySorties:records.flySorties,
              miles:records.miles   ,
              safeHours:records.safeHours,
              safeHoursArr:records.monthHours.map(v=>{
                return [v.month,v.hours]
              }),
              numsArr:records.monthHours.map(v=>{
                return [v.month,v.nums]
              }),
              milesArr:records.monthHours.map(v=>{
                return [v.month,v.miles]
              }),
            }
          }
        })
    },
    //获取飞行器数据
    getAircraft(){
      return  this.getRequest(
        '/uav-task-server/planstatistic/getAircraft'
      ).then(
        res => {
          let oData = res.data;
          if (oData.code == 0) {
            let records = oData.data;
            this.aircraftData = {
              totalNum:records.totalNum,
              flyingNum:records.flyingNum,
              detail:records.detail.slice(0,3).map(v=>{
                return {...v,rate:parseFloat((v.num/records.totalNum*100).toFixed(2))}
              })
            }
          }
        })
    },
    //左侧可切换折线图
    initChangeChart() {
      let _this = this
      //TODO 请求接口
      this.myChart1 = echarts.init(document.getElementById('flyDataCharts'));
      this.myChart1.setOption({
         tooltip: {
          trigger: 'axis', // 鼠标悬停时触发
          formatter: function (params) {
            let result = `<strong>${params[0].name}</strong><br/>`; // 显示时间
            params.forEach(item => {
              result += `${_this.chartType === 1 ? '运行小时数' : _this.chartType === 2 ? '运行架次' : '运行里程'}: ${item.value[1]}${_this.chartType === 1 ? '小时' : _this.chartType === 2 ? '次' : 'km'}<br/>`; // 显示数据
            });
            return result;
          },
          backgroundColor: '#fff',
          borderColor: '#ccc',
          borderWidth: 1,
          padding: 10,
          textStyle: {
            color: '#333',
            fontSize: 14
          }
        },
        grid: {
          top: 33,
          left: 50,
          right: 30,
          bottom: 20,
          width: 'auto',
          height: 'auto',
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)', // 坐标轴颜色
            }
          },
          axisLabel: {
            color: '#fff', // 坐标字体颜色
          },
          axisTick: {
            show: false, // 去掉轴刻度线
          },
        },
        yAxis: {
          name: this.chartType === 1 ? '(小时)' : this.chartType === 2 ? '(次)' : '(km)',
          type: 'value',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)', // 坐标轴颜色
            }
          },
          axisLabel: {
            color: '#fff', // 坐标字体颜色
          },
          axisTick: {
            show: false, // 去掉轴刻度线
          },
          nameTextStyle: {
            color: '#fff',
          },
          splitLine: {
            //网格线
            lineStyle: {
              type: "solid",
              color: "rgba(255, 255, 255, 0.3)"
            },
            show: true,
          },
        },
        series: [
          {
            type: 'line',
             showSymbol: false, // 隐藏所有数据点
            // smooth: 1,
            lineStyle: {
              color: '#00AEFF',
              width: 3
            },
            areaStyle: {
              normal: {
                color: {
                  type: 'linear', // 线性渐变
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    { offset: 0, color: '#00AEFF' }, // 0% 处的颜色
                    { offset: 1, color: 'rgba(0, 174, 255, 0)' }  // 100% 处的颜色
                  ],
                  global: false // 使用区域渐变
                }
              }
            },
            data: this.chartType === 1 ? this.planViewData.safeHoursArr : this.chartType === 2 ? this.planViewData.numsArr : this.planViewData.milesArr,
            itemStyle: {
              // 设置数据点的大小和样式
              color: '#00AEFF', // 数据点颜色
              borderColor: '#00AEFF',
              borderWidth: 1, // 边框宽度
            },
          }

        ]
      });
    },
    showPlanDetail(info){
      console.log(info)
      this.taskForm = info
      this.clickButton = true
    },
    updateDialogVisible(newVal){
      this.clickButton = newVal
    },
    closeForm(value){
      this.clickButton = value
    },
    initCharts() {
      this.rightTop = echarts.init(document.getElementById('flyDataCharts'));
      this.rightCenter = echarts.init(document.getElementById('flyActiveCharts'));
      this.drawCharts();
    },
    drawCharts() {
      this.setChartOptions(this.rightTop, this.getRightTopOptions());
      this.setChartOptions(this.rightCenter, this.getRightCenterOptions());
    },
    setChartOptions(chart, options) {
      chart.setOption(options);
    },
    getRightTopOptions() {
      let _this = this
      return {
        tooltip: {
          trigger: 'axis', // 鼠标悬停时触发
          formatter: function (params) {
            let result = `<strong>${params[0].name}</strong><br/>`; // 显示时间
            params.forEach(item => {
              result += `${_this.chartType === 1 ? '运行小时数' : _this.chartType === 2 ? '运行架次' : '运行里程'}: ${item.value[1]}${_this.chartType === 1 ? '小时' : _this.chartType === 2 ? '次' : 'km'}<br/>`; // 显示数据
            });
            return result;
          },
          backgroundColor: '#fff',
          borderColor: '#ccc',
          borderWidth: 1,
          padding: 10,
          textStyle: {
            color: '#333',
            fontSize: 14
          }
        },
        grid: {
          top: 33,
          left: 50,
          right: 30,
          bottom: 20,
          width: 'auto',
          height: 'auto',
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)', // 坐标轴颜色
            }
          },
          axisLabel: {
            color: '#fff', // 坐标字体颜色
          },
          axisTick: {
            show: false, // 去掉轴刻度线
          },
        },
        yAxis: {
          name: this.chartType === 1 ? '(小时)' : this.chartType === 2 ? '(次)' : '(km)',
          type: 'value',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)', // 坐标轴颜色
            }
          },
          axisLabel: {
            color: '#fff', // 坐标字体颜色
          },
          axisTick: {
            show: false, // 去掉轴刻度线
          },
          nameTextStyle: {
            color: '#fff',
          },
          splitLine: {
            //网格线
            lineStyle: {
              type: "solid",
              color: "rgba(255, 255, 255, 0.3)"
            },
            show: true,
          },
        },
        series: [
          {
            type: 'line',
             showSymbol: false, // 隐藏所有数据点
            // smooth: 1,
            lineStyle: {
              color: '#00AEFF',
              width: 3
            },
            areaStyle: {
              normal: {
                color: {
                  type: 'linear', // 线性渐变
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    { offset: 0, color: '#00AEFF' }, // 0% 处的颜色
                    { offset: 1, color: 'rgba(0, 174, 255, 0)' }  // 100% 处的颜色
                  ],
                  global: false // 使用区域渐变
                }
              }
            },
            data: this.chartType === 1 ? this.planViewData.safeHoursArr : this.chartType === 2 ? this.planViewData.numsArr : this.planViewData.milesArr,
            itemStyle: {
              // 设置数据点的大小和样式
              color: '#00AEFF', // 数据点颜色
              borderColor: '#00AEFF',
              borderWidth: 1, // 边框宽度
            },
          }

        ]
      }
    },
    getRightCenterOptions() {
      return {
        tooltip: {
          trigger: 'axis', // 鼠标悬停时触发
          formatter: function (params) {
            let result = `<strong>${params[0].name}</strong><br/>`; // 显示时间
            params.forEach(item => {
              result += `飞行次数: ${item.value[1]}次<br/>`; // 显示数据
            });
            return result;
          },
          backgroundColor: '#fff',
          borderColor: '#ccc',
          borderWidth: 1,
          padding: 10,
          textStyle: {
            color: '#333',
            fontSize: 14
          }
        },
        grid: {
          top: 33,
          left: 50,
          right: 30,
          bottom: 20,
          width: 'auto',
          height: 'auto',
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)', // 坐标轴颜色
            }
          },
          axisLabel: {
            color: '#fff', // 坐标字体颜色
          },
          axisTick: {
            show: false, // 去掉轴刻度线
          },
        },
        yAxis: {
          name: '(次)',
          type: 'value',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)', // 坐标轴颜色
            }
          },
          axisLabel: {
            color: '#fff', // 坐标字体颜色
          },
          axisTick: {
            show: false, // 去掉轴刻度线
          },
          nameTextStyle: {
            color: '#fff',
          },
          splitLine: {
            //网格线
            lineStyle: {
              type: "solid",
              color: "rgba(255, 255, 255, 0.3)"
            },
            show: true,
          },
        },
        series: [
          {
            type: 'line',
            showSymbol: false, // 隐藏所有数据点
            // smooth: 1,
            lineStyle: {
              color: this.isEyeshield?'#fff':'#00ffff',
              width: 3
            },
            areaStyle: {
              normal: {
                color: {
                  type: 'linear', // 线性渐变
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    { offset: 0,color: this.isEyeshield?'rgba(255,255,255,0.80)':'#00FFFF' }, // 0% 处的颜色
                    { offset: 1, color: this.isEyeshield?'rgba(255,255,255,0.00)':'rgba(0, 255, 255, 0)' }  // 100% 处的颜色
                  ],
                  global: false // 使用区域渐变
                }
              }
            },
            data: this.planActivity.TimesArr,
            itemStyle: {
              // 设置数据点的大小和样式
              color: '#00FFFF', // 数据点颜色
              borderColor: '#00FFFF',
              borderWidth: 1, // 边框宽度
            },
          }

        ]
      }
    },
    async getPageData(){
      await Promise.all([
        this.getPlanView(),
        this.getPlanActivity(),
        this.getFacilitiesData(),
        this.getAircraft(),

      ]).then(res=>{
        this.initCharts()
      }).catch(e=>{
        this.initCharts()
      })

    },
    searchClick(v){
      this.queryPlan(v);
    },
    queryPlan() {
      this.getRequest(
        `/uav-task-server/plandto/queryPlanByConditionNoStatus?pagesize=100&keyWord=${this.searchTaskKeyWord}`
      ).then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          let records = oData.data.list;
          if (records && records.length > 0) {
            // let simpleArray = records.map(item => ({
            //   id: item.id,
            //   planSerial: item.planSerial,
            //   uavSerial: item.uavSerial,
            //   uavModel: item.uavModel,
            //   pilot: item.pilot,
            //   type: item.type,
            //   status: item.status,
            //   airpointList: item.airpointList
            // }));
            this.taskList = records;
          } else {
            this.taskList = [];
          }
        } else {
          this.$message.error({
            message: oData.msg,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () {
            },
          });
        }
      });
    },
    toLogistics(){
      const payload = {
        username: 'admin',
        password: 'Admin@123123',
        flag: 1,
      };

      // 使用 Fetch API 进行 AJAX 请求
      fetch(this.loginUrl+'/api/manage/api/v1/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('网络错误或登录失败');
          }
          return response.json();
        })
        .then(data => {
          if(data.code === 0){
            const access_token = data.data.access_token;q
            const url = `${this.loginUrl}?token=${encodeURIComponent(access_token)}`;
            window.open(url, '_blank'); // 使用 '_blank' 在新标签页中打开
          }
          // this.openNewWindow(token);
        })
        .catch(error => {
          console.error('登录失败:', error);
        });
    },
    setTime() {
      const d = new Date();
      const dStr = this.$moment(d).format("YYYY-MM-DD HH:mm:ss");
      const dStrArr = dStr.split(" ");
      this.$data.timeInfo.currentTime = dStrArr[1];
      this.$data.timeInfo.date = dStrArr[0];
      const day = d.getDay();
      const weeks = ["星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"];
      this.$data.timeInfo.weekday = weeks[day];
    },
    handleResize() {
      this.rightCenter.resize();
      this.rightTop.resize();
    },
  },
}
</script>
<style scoped>
@import "../../../assets/css/home/DashboardIndex.scss"
</style>



// WEBPACK FOOTER //
// src/components/dashboard/components/Index.vue